import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/layouts/default.vue"))
}